import { render } from "./AddAnnouncement.vue?vue&type=template&id=15f8b7c6&scoped=true"
import script from "./AddAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddAnnouncement.vue?vue&type=style&index=1&id=15f8b7c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f8b7c6"]])

export default __exports__